var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStripeClimateBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "StripeClimate-gradient-a",
    gradientUnits: "userSpaceOnUse",
    x1: 16,
    y1: 20.6293,
    x2: 16,
    y2: 7.8394,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00cb1b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.82h32c0 8.84-7.16 16-16 16s-16-7.16-16-16z",
    fill: "url(#StripeClimate-gradient-a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "StripeClimate-gradient-b",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    y1: 28.6289,
    x2: 24,
    y2: 17.2443,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1562,
    stopColor: "#009c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00be20"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10.82c0 2.21-1.49 4.65-5.41 4.65-3.42 0-7.27-2.37-10.59-4.65 3.52-2.43 7.39-5.63 10.59-5.63C29.86 5.18 32 8.17 32 10.82z",
    fill: "url(#StripeClimate-gradient-b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "StripeClimate-gradient-c",
    gradientUnits: "userSpaceOnUse",
    x1: 8,
    y1: 16.7494,
    x2: 8,
    y2: 29.1239,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe37d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc900"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.82c0 2.21 1.49 4.65 5.41 4.65 3.42 0 7.27-2.37 10.59-4.65-3.52-2.43-7.39-5.64-10.59-5.64C2.14 5.18 0 8.17 0 10.82z",
    fill: "url(#StripeClimate-gradient-c)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeClimateBadge);
export default __webpack_public_path__ + "static/media/Stripe Climate Badge.26ee17ca87b71ac799069233ad64a82a.svg";
export { ForwardRef as ReactComponent };